module.exports = __webpack_public_path__ + "img/empty-box.526b44a8.svg";